import { Routes, Route } from "react-router-dom";
import { FormPageLayout } from "./components/FormPageLayout";
import { Login } from "./pages/Login";
import { ChangePassword } from "./pages/ChangePassword";
import { Logout } from "./pages/Logout";
import { AppLayout } from "./components/AppLayout";
import { Account } from "./pages/Account";
import { Dashboard } from "./pages/Dashboard";
import { CreatePassword } from "./pages/CreatePassword";
import { RequestPasswordChange } from "./pages/RequestPasswordChange";
import { Divertor } from './components/Divertor';
import { StartupLibrary } from './pages/StartupLibrary';
import { Scans } from './pages/Scans';
import { Learning } from './pages/Learning';
import { Review } from './pages/Review';
import { PortfolioDashboard } from './pages/PortfolioDashboard';
import { Benchmark } from './pages/Benchmark';
import { RequestProgressScan } from './pages/RequestProgressScan';
import { Organisations } from './pages/Organisations';
import { NewOrganisation } from './pages/NewOrganisation';
import { StartupAccount } from './pages/StartupAccount';
import { EditOrganisation } from './pages/EditOrganisation';
import Assessment from './assessment/components/Assessment';
import Endpoint from './assessment/components/Endpoint';
import { AssessmentWrapper } from './assessment/components/AssessmentWrapper';
import { Home } from './pages/Home';
import { Progress } from './pages/Progress';
import {MinimalDashboard} from "./pages/MinimalDashboard";

export const AppRoutesStartupLib = () => {
  return (
    <Routes>
      <Route element={<FormPageLayout />}>
        <Route path="/login" element={<Login />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/create-password" element={<CreatePassword />} />
        <Route path="/request-change-password" element={<RequestPasswordChange />}/>
      </Route>
      <Route element={<AppLayout />}>
        <Route path="/" element={<Divertor />} >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/account" element={<Account />} />
          <Route path="/library/home" element={<Home />} />
          <Route path="/library/scans" element={<Scans />} />
          <Route path="/library/review" element={<Review />} />
          <Route path="/library/progress" element={<Progress />} />
          <Route path="/library/review/:assessmentUuid" element={<Review />} />
          <Route path="/library/minimal-dashboard" element={<MinimalDashboard />} />
          <Route path="/library/portfolio-dashboard" element={<PortfolioDashboard />} />
          <Route path="/library/benchmark" element={<Benchmark />} />
          <Route path="/library/startups" element={<StartupLibrary />} />
          <Route path="/library/learning" element={<Learning />} />
          <Route path="/library/request-progress-scan" element={<RequestProgressScan />} />
          <Route path="/admin/organisations" element={<Organisations />} />
          <Route path="/admin/organisations/create" element={<NewOrganisation />} />
          <Route path="/admin/organisations/:id/edit" element={<EditOrganisation />} />
          <Route path="/startup/startupaccount" element={<StartupAccount />} />
        </Route>
      </Route>
      <Route element={<AssessmentWrapper/>}>
        <Route path="/assessments/assessment/:assessmentId/:questionNumber" element={<Assessment />} />
        <Route path="/assessments/:institution/:assessmentType" element={<Endpoint />}/>
        <Route path="/assessments/:institution/:assessmentType/:language" element={<Endpoint />}/>
      </Route>
    </Routes>
  );
};
